export const csvDefault = `施設ID,部屋タイプID,日付,SP,FP,DP,VS（1人）,VS（2人）,VS（3人）,VS（4人）,VS（5人）,VS（6人）,VS（7人）,VS（8人）,VS（9人）,VS（10人）,MO（1人）,MO（2人）,MO（3人）,MO（4人）,MO（5人）,MO（6人）,MO（7人）,MO（8人）,MO（9人）,MO（10人）
1,1,2021/05/18,5,5,10000,1000,2000,3000,4000,5000,6000,7000,8000,9000,10000,21000,22000,23000,24000,25000,26000,27000,28000,29000,30000
`
